import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { QueryConfig, PageDtoV2SegmentRptV2, PageAndSortParamsType } from 'types';

export interface Segment3SearchParamsType extends PageAndSortParamsType {
  name?: string | null;
  code?: string | null;
  discontinued?: boolean;
}

export const getSegment3s = (chartOfAccountsId: number, searchParams?: Segment3SearchParamsType) => {
  return httpv2.get<PageDtoV2SegmentRptV2>(`/charts-of-accounts/${chartOfAccountsId}/segment3`, {
    params: searchParams,
  });
};

export const getSegment3sQueryOptions = (chartOfAccountsId: number, searchParams?: Segment3SearchParamsType) => {
  return queryOptions({
    queryKey: ['charts-of-accounts', chartOfAccountsId, 'segment3', { searchParams: { ...searchParams } }],
    queryFn: () => getSegment3s(chartOfAccountsId, searchParams),
  });
};

type UseSegment3sOptions = {
  chartOfAccountsId: number;
  searchParams?: Segment3SearchParamsType;
  queryConfig?: QueryConfig<typeof getSegment3sQueryOptions>;
};

export const useSuspenseSegment3s = ({ chartOfAccountsId, searchParams, queryConfig }: UseSegment3sOptions) => {
  return useSuspenseQuery({
    ...getSegment3sQueryOptions(chartOfAccountsId, searchParams),
    ...queryConfig,
  });
};
